import {Inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {Observable, ReplaySubject} from "rxjs";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {first, take} from "rxjs/operators";
import {HiperioTestAccessForm} from "../interface/hiperio-test-access-form";

@Injectable({
  providedIn: 'root'
})
export class HiperioTestAccessFormService {
  public readonly formListSubject: ReplaySubject<CountedAndPaginated<HiperioTestAccessForm>>
    = new ReplaySubject<CountedAndPaginated<HiperioTestAccessForm>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public loadList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/hiperio/test-access-form?page=${page + 1}&pageSize=${pageSize}&`
      + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<HiperioTestAccessForm>) => {
        this.formListSubject.next(result);
      });
  }

  updateStatus(uuid: string, status: number): Observable<any> {
    return this.httpClient.post(`/rest/crm/hiperio/test-access-form/${uuid}`,
      {
        status: status,
      })
      .pipe(take(1));
  }
}
